export default __webpack_public_path__ + "static/Flexible_IOT-13c4115ce51d8b9246cf31dfb81e3c15.png";